import { type CSSProperties, createElement, type ReactNode } from 'react';

import classNames from 'classnames';

import type { StripeCardElementComponent, StripePaymentElementComponent } from '../../types';
import { DEFAULT_PAYMENT_ELEMENT_OPTIONS } from '../Pricing.constants';
import { input, inputSubmit } from '../Pricing.css';

interface Props {
  isInternalCheckout: boolean;
  StripeCardElement?: StripeCardElementComponent;
  StripePaymentElement?: StripePaymentElementComponent;
  inputTextColor?: CSSProperties['color'];
  inputPlaceholderColor?: CSSProperties['color'];
  inputBackgroundColor?: CSSProperties['backgroundColor'];
  showTaxIdField: boolean;
  taxId: string;
  onTaxIdChange: (value: string) => void;
  gdprField?: ReactNode;
  ctaText: string;
  isCtaDisabled: boolean;
}

const CheckoutPaymentSection = ({
  isInternalCheckout,
  StripeCardElement,
  StripePaymentElement,
  inputTextColor,
  inputPlaceholderColor,
  inputBackgroundColor,
  showTaxIdField,
  taxId,
  onTaxIdChange,
  gdprField,
  ctaText,
  isCtaDisabled,
}: Props) => (
  <>
    {isInternalCheckout && StripeCardElement
      ? createElement(StripeCardElement, {
          className: classNames('border py-3 px-4 rounded-md', input),
          options: {
            style: {
              base: {
                backgroundColor: inputBackgroundColor,
                fontSize: '14px',
                color: inputTextColor,
                '::placeholder': { color: inputPlaceholderColor },
              },
            },
          },
        })
      : null}
    {isInternalCheckout && StripePaymentElement
      ? createElement(StripePaymentElement, {
          options: { ...DEFAULT_PAYMENT_ELEMENT_OPTIONS },
        })
      : null}
    {isInternalCheckout && !StripeCardElement && !StripePaymentElement ? (
      <input type="text" placeholder="Credit Card Placeholder" className={classNames('py-2 px-4', input)} />
    ) : null}
    {showTaxIdField && (
      <input
        type="text"
        name="tax_id"
        placeholder="Tax ID"
        defaultValue={taxId}
        onBlur={(e) => onTaxIdChange(e.target.value)}
        className={classNames('py-2 px-4', input)}
      />
    )}
    {gdprField}
    <input
      disabled={isCtaDisabled}
      type="submit"
      value={ctaText}
      className={classNames(inputSubmit, 'rounded-md py-2 px-4')}
    />
  </>
);

export default CheckoutPaymentSection;
